import { render, staticRenderFns } from "./GraphQLPricing.vue?vue&type=template&id=528c1cc6&scoped=true&"
import script from "./GraphQLPricing.vue?vue&type=script&lang=js&"
export * from "./GraphQLPricing.vue?vue&type=script&lang=js&"
import style0 from "./GraphQLPricing.vue?vue&type=style&index=0&id=528c1cc6&lang=scss&scoped=true&"
import style1 from "./GraphQLPricing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c1cc6",
  null
  
)

export default component.exports